import DOMPurify from "dompurify";

// Posts only support Bold / Italic / Underline. Allow exactly the tags those
// produce (plus the block/line tags Quill wraps content in). Everything else —
// scripts, links, images, event handlers — is stripped.
const ALLOWED = {
  ALLOWED_TAGS: ["b", "strong", "i", "em", "u", "p", "br", "span"],
  ALLOWED_ATTR: [],
};

/**
 * Sanitize a post's `description` for safe rendering via dangerouslySetInnerHTML.
 * Legacy posts are plain text (no tags); their newlines are converted to <br>
 * so they keep rendering with line breaks.
 */
export const renderPostHtml = (raw) => {
  if (!raw) return "";
  const str = String(raw);
  const looksHtml = /<\/?[a-z][\s\S]*>/i.test(str);
  const html = looksHtml ? str : str.replace(/\n/g, "<br>");
  return DOMPurify.sanitize(html, ALLOWED);
};

/** Visible-text length (tags stripped) — for "show more" thresholds. */
export const getPostTextLength = (raw) => {
  if (!raw) return 0;
  return String(raw)
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim().length;
};
